export default class NoPACSCommunicationError extends Error {
  constructor() {
    super('No PACSCommunication available');
    this.name = 'NoPACSCommunicationError';
  }
}
